// removed by extract-text-webpack-plugin
module.exports = {"DropDown":"_3gFcXTeHb6_COMIxfypXhu","DropDown__value":"_1jXMzKpoyM0frla_N_HowQ","DropDown__options":"FvuPy_NrGaTTddFQ21TrK","DropDown__options--open":"uJdwy1HAzQZb-9_eBJ45x","DropDown__option":"_2GaBUzR9K19iQq7AvgBcHw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LibraryNavBarDropDown/LibraryNavBarDropDown.scss
// module id = 2624
// module chunks = 0